import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { GoalSection } from './components/GoalSection';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusesSection } from './components/BonusesSection';
import { NotJustInfoSection } from './components/NotJustInfoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
const PIXEL_ID = '2226605141499138';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const first = document.getElementsByTagName('script')[0];
    first?.parentNode?.insertBefore(script, first);
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-white font-sans text-coal selection:bg-solar selection:text-coal" data-id="element-0" data-mp="3dkl0k0ecojeo">
      <noscript data-id="element-1" data-mp="nwc2huqftzxb">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="nuhjilyq8hvv" />
      </noscript>

      <Hero data-id="element-3" data-mp="34nabp7octvk" />
      <main data-id="element-4" data-mp="38kv0f9whthk">
        <ProblemSection data-id="element-5" data-mp="3uct3pkqacp10" />
        <GoalSection data-id="element-6" data-mp="3udaxmaph6r5r" />
        <SystemSection data-id="element-7" data-mp="3ubzso7kandd2" />
        <ModulesSection data-id="element-8" data-mp="3ucje3y95kjvu" />
        <BonusesSection data-id="element-9" data-mp="d4nvzht0nm2x" />
        <NotJustInfoSection data-id="element-10" data-mp="d4xphfd9sbdd" />
        <PricingSection data-id="element-11" data-mp="d45t42bum9m1" />
        <GuaranteeSection data-id="element-12" data-mp="d2l6cyvrzuyq" />
        <TestimonialsSection data-id="element-13" data-mp="85ully910b6z" />
        <FAQSection data-id="element-14" data-mp="86w6svjrae2f" />
        <FinalCTA data-id="element-15" data-mp="86cmj86mvdl8" />
      </main>
      <Footer data-id="element-16" data-mp="3glea6jyr55fp" />
      {showPurchasePopup && <PurchasePopup data-id="element-17" data-mp="3gmfu7dxqx29k" />}
    </div>;
}